import React, { useState, useEffect, useRef, useCallback } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Switch } from "@headlessui/react";
import Select from "react-select";
import { baseUrl } from "../../Environments/environment";

import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
import { toast } from "react-toastify";

import countries from "../../utils/countries";
import { apiClient } from "../../api";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
let standardCheckInTime = null;
let standardCheckOutTime = null;


function AddGuestModal({ isOpen, onClose }) {
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const { selectedPropertyId, propertyTimezone, propertyName } = useProperty();


  const [selectedCountry, setSelectedCountry] = useState("");
  const [countryCode, setCountryCode] = useState("+1");
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(undefined);
  const [arrivalDate, setArrivalDate] = useState();
  const [arrivalTime, setArrivalTime] = useState();
  const [firstName, setFirstName] = useState(undefined);
  const [lastName, setLastName] = useState(undefined);
  const [email, setEmail] = useState(undefined);
  const [sendMessage, setSendMessage] = useState(true);
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  const [guestAddingLoader, setGuestAddingLoader] = useState(false);
  const [customFlows, setCustomFlows] = useState();
  const [requireFields, setRequireFields] = useState({
    email: false,
    firstName: false,
    lastName: false,
  });
  const [selectedListings, setSelectedListings] = useState([]);
  const [reviewsJobFlow, setReviewsJobFlow] = useState([]);
  const checkIn = `${arrivalDate}T${arrivalTime}Z`;
  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };


    setArrivalDate(formatDate(today));
  }, [isOpen]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the dropdown and the trigger button
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm("");
      }
    };

    // Only add the event listener if the dropdown is open
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);
  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
    if (!isDropdownOpen) {
      // Reset search when opening
      setSearchTerm("");
      // Focus search input after opening
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  };

  const setTiming = useCallback(async () => {
    try {
      if (!standardCheckInTime || !standardCheckOutTime) {
        const response = await apiClient.get(
          `${baseUrl}/setting/${selectedPropertyId}`
        );
        if (response.ok) {
          const newToken = response.headers.get("Authorization");
          if (newToken) {
            localStorage.setItem("accessToken", newToken.split(" ")[1]);
          }
        }
        standardCheckInTime = response.data.result.setting.standardCheckinTime;
        standardCheckOutTime =
          response.data.result.setting.standardCheckoutTime;
      }
      setArrivalTime(standardCheckInTime);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  }, [selectedPropertyId]);

  useEffect(() => {
    setTiming();
  }, [isOpen, setTiming]);

  const getCustomFlows = useCallback(async () => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/customFlow/${selectedPropertyId}`
      );
      if (response.status === 200) {
        const newToken = response.headers["authorization"];
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]);
        }

        if (response.data?.result?.length > 0) {
          console.log("DATAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response.data);
          setCustomFlows([...response.data.result].reverse());
        } else {
          console.warn("No flows found");
          setCustomFlows([...response.data.result.customFlow].reverse());
        }
      } else {
        console.error("API error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [selectedPropertyId]);
  const fetchReviewJobs = useCallback(async () => {
    try {
      const token = localStorage.getItem("accessToken");

      const response = await apiClient.get(
        `${baseUrl}/reviews/jobs/${selectedPropertyId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusCode === 200) {
        const rjs = (response.data.result.reviewJobs || []).map((r) => {
          return {
            value: r.network,
            label: r.network.charAt(0).toUpperCase() + r.network.slice(1),
          };
        });
        setSelectedListings(rjs);
        setReviewsJobFlow(rjs);
      }
    } catch (error) {
      console.error("Error fetching review jobs:", error);
    }
  }, [selectedPropertyId]);
  const getRequireFieldSetting = useCallback(async () => {
    try {
      const response = await apiClient.get(
        `${baseUrl}/requireFieldSetting/${selectedPropertyId}`
      );
      if (response.status === 200) {
        console.log(response);
        if (response?.data?.result?.setting) {
          const s = response?.data?.result?.setting;
          setRequireFields({
            email: s?.email ?? false,
            firstName: s?.firstName ?? false,
            lastName: s?.lastName ?? false,
          });
        }
      } else {
        console.error("API error:", response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [selectedPropertyId]);

  useEffect(() => {
    getCustomFlows();
    getRequireFieldSetting();
    fetchReviewJobs();
  }, [isOpen, getCustomFlows, getRequireFieldSetting, fetchReviewJobs]);

  if (!isOpen) return null;
  const toggleMessageVisibility = () => {
    setIsMessageVisible(!isMessageVisible);
  };

  const resetFields = () => {
    setCountryCode("+1");
    setPhoneNumber();
    setArrivalDate();
    setArrivalTime();
    setFirstName();
    setLastName();
    setEmail();
    setSendMessage(true);
    setIsMessageVisible(false);
  };

  // const sendCustomMessages = async (status,guest) => {
  // 	const bodyData = {
  // 		messageId: "66b8e563d932866db03735d6",
  // 		sendMessage: true,
  // 		status,
  // 		guest
  // 	}
  // 	try {
  // 		const response = await apiClient.post(
  // 			`${baseUrl}/customMessage/${selectedPropertyId}`,
  // 			bodyData
  // 		);
  // 		console.log("Response ------",response.data)
  // 	} catch (error) {
  // 		console.error("-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",error)
  // 	}
  // }

  const sendCustomMessages = async (status, guest) => {
    if (!customFlows || customFlows.length === 0) {
      await getCustomFlows();
    }
    console.log(customFlows);
    const filteredFlows = customFlows.filter(
      (flow) =>
        flow.trigger.toLowerCase() === "after guest moved to in-house" &&
        flow.flowStatus === true
    );

    console.log(status);
    if (status.currentStatus === "In House") {
      for (const flow of filteredFlows) {
        const bodyData = {
          messageId: flow.messageTemplateId,
          sendMessage: true,
          status,
          guest,
        };
        console.log(flow);
        try {
          const response = await apiClient.post(
            `${baseUrl}/customMessage/${selectedPropertyId}`,
            bodyData
          );
          console.log("Response ------", response.data);
        } catch (error) {
          console.error(
            "-------------------------ERROR WHILE SENDING CUSTOM MESSAGE---------------",
            error
          );
        }
      }
    }
  };

  const handleAddGuest = async () => {
    const capitalizeFirstLetter = (str) => {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : undefined;
    };
    if (!phoneNumber && !email) {
      toast.error("Either Phone Number or Email is required!");
      return;
    } else if (!email && requireFields.email) {
      toast.error("Email is required !");
      return;
    } else if (!firstName && requireFields.firstName) {
      toast.error("FirstName is required !");
      return;
    } else if (!lastName && requireFields.lastName) {
      toast.error("LastName is required !");
      return;
    }
    const guestData = {
      email: email === "" ? undefined : email,

      lastName: lastName === "" ? undefined : capitalizeFirstLetter(lastName),
      firstName:
        firstName === "" ? undefined : capitalizeFirstLetter(firstName),
      countryCode: !phoneNumber ? undefined : countryCode,
      phoneNumber: phoneNumber === "" ? undefined : phoneNumber,
      listing: Array.isArray(selectedListings) ? selectedListings.map((r) => {
        return { network: r.value };
      }) : [],
      sendMessage,
    };

    try {
      console.log(guestData);
      // console.log("urllll", baseUrl);
      // eslint-disable-next-line
      setGuestAddingLoader(true);
      const response = await apiClient.post(
        `${baseUrl}/guest/${selectedPropertyId}`,
        guestData
      );
      //console.warn(response.data)
      const newGuest = response.data.result.guest;
      await sendCustomMessages(newGuest.status, newGuest);
      //const customMessage =
      if (response.ok) {
        const newToken = response.headers.get("Authorization");
        if (newToken) {
          localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
        }
      }
      setGuestAddingLoader(false);
      toast.success(response.data.message);
      // Reset state values after successful API call
      resetFields();
      onClose();
    } catch (error) {
      // console.log(error);
      setGuestAddingLoader(false);
      let errorMessage =
        error.response?.data?.message ||
        "Failed to add the guest. Please try again.";
      if (error.response?.data?.error.firstName !== undefined) {
        errorMessage =
          "First name is " + error.response?.data?.error.firstName[0];
      } else if (error.response?.data?.error.lastName !== undefined) {
        errorMessage =
          "Last name is " + error.response?.data?.error.lastName[0];
      } else if (
        error.response?.data?.error.phoneNumber !== undefined &&
        phoneNumber === undefined
      ) {
        errorMessage = error.response?.data?.error.phoneNumber[0];
      } else if (error.response?.data?.error.phoneNumber !== undefined) {
        errorMessage = error.response?.data?.error.phoneNumber[0];
      } else if (error.response?.data?.error.checkIn !== undefined) {
        errorMessage = "For Check In " + error.response?.data?.error.checkIn[0];
      } else if (error.response?.data?.error.checkOut !== undefined) {
        errorMessage =
          "For Check Out " + error.response?.data?.error.checkOut[0];
      } else if (error.response?.data?.error.email !== undefined) {
        errorMessage = error.response?.data?.error.email[0];
      } else if (error.response?.data?.error.roomNumber !== undefined) {
        errorMessage = error.response?.data?.error.roomNumber[0];
      }
      // console.log(error.response?.data?.error);
      toast.error(errorMessage);
    }
  };



  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setSearchTerm(""); // Clear search term on selection
    setIsDropdownOpen(false); // Close the dropdown
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
      {/* New Guest Modal */}
      <div
        className={`bg-white rounded-lg shadow-xl w-full max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-3xl lg:w-[70vh] ${
          isMessageVisible && "lg:h-[90vh]"
        } max-h-[95vh] overflow-y-auto p-4 sm:p-5 md:p-6 space-y-4 sm:space-y-5 md:space-y-6 lg:space-y-7`}
      >
        <div className="flex justify-between items-center">
          <h2 className="text-base sm:text-lg font-semibold">Request Review</h2>
          <button
            onClick={() => {
              resetFields();
              onClose();
            }}
            className="text-gray-600 hover:text-gray-900 p-1"
            aria-label="Close modal"
          >
            <AiOutlineClose size={20} />
          </button>
        </div>

        <div className="w-full space-y-4 sm:space-y-5">
          <hr />

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <div className="w-full sm:w-1/2">
              <label
                className={`block text-xs sm:text-[13px] font-semibold mb-1 sm:mb-1.5 text-gray-700`}
              >
                First Name
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="block w-full rounded-md border border-gray-300 px-3 py-2 sm:py-1.5 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
              />
            </div>
            <div className="w-full sm:w-1/2">
              <label
                className={`block text-xs sm:text-[13px] font-semibold mb-1 sm:mb-1.5 text-gray-700`}
              >
                Last Name
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="block w-full rounded-md border border-gray-300 px-3 py-2 sm:py-1.5 text-sm focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 placeholder:text-gray-300 placeholder:font-light"
              />
            </div>
          </div>

          <div className="space-y-4 w-full">
            <div className="space-y-2">
              <label className="block text-xs sm:text-sm font-medium text-gray-700">
                Phone Number
              </label>
              <div className="relative">
                <div className="flex">
                  <div className="relative w-[100px] sm:w-[120px] flex-shrink-0">
                    <button
                      type="button"
                      onClick={toggleDropdown}
                      className="w-full h-full flex items-center justify-between px-2 sm:px-3 py-2 border border-gray-300 bg-white rounded-l-md text-xs sm:text-sm hover:bg-gray-50 transition-colors"
                    >
                      <span className="flex items-center gap-1 sm:gap-2 truncate">
                        {selectedCountry ? (
                          <>
                            <span className="truncate">{selectedCountry.code}</span>
                          </>
                        ) : (
                          "+1"
                        )}
                      </span>
                      <svg
                        className={`w-3 h-3 sm:w-4 sm:h-4 text-gray-400 transition-transform duration-200 flex-shrink-0 ${
                          isDropdownOpen ? "rotate-180" : ""
                        }`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                      </svg>
                    </button>
                  </div>
                  <input
                    type="tel"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Enter phone number"
                    className="flex-1 min-w-0 w-full rounded-r-md border border-l-0 border-gray-300 
                       px-3 py-2 text-xs sm:text-sm text-gray-700 
                       focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                       placeholder:text-gray-400"
                  />
                </div>

                {/* Dropdown */}
                {isDropdownOpen && (
                  <div
                    ref={dropdownRef}
                    className="absolute top-full left-0 mt-1 w-full sm:w-64 bg-white border border-gray-200 rounded-md shadow-lg z-50"
                  >
                    <div className="p-2">
                      <input
                        ref={searchInputRef}
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search country..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-xs sm:text-sm
                           focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                           placeholder:text-gray-400"
                      />
                    </div>
                    <div className="max-h-48 sm:max-h-60 overflow-y-auto">
                      {Array.isArray(filteredCountries) && filteredCountries.map((country) => (
                        <div
                          key={country.code}
                          className="px-3 sm:px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2 sm:gap-3 text-xs sm:text-sm"
                          onClick={() => handleCountrySelect(country)}
                        >
                          <span className="text-base sm:text-lg">{country.flag}</span>
                          <span className="text-gray-700 flex-1 truncate">{country.name}</span>
                          <span className="text-gray-500 flex-shrink-0">
                            {country.code}
                          </span>
                        </div>
                      ))}
                      {filteredCountries.length === 0 && (
                        <div className="px-3 sm:px-4 py-2 text-xs sm:text-sm text-gray-500">
                          No countries found
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="space-y-2">
              <label className="block text-xs sm:text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full rounded-md border border-gray-300 
                   px-3 py-2 text-xs sm:text-sm text-gray-700 
                   focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500
                   placeholder:text-gray-400"
              />
            </div>
            <div className="text-xs sm:text-sm">
              <Select
                isMulti
                options={reviewsJobFlow}
                value={selectedListings}
                onChange={(selected) => setSelectedListings(selected)}
                placeholder="Select platforms..."
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: '0.875rem',
                    minHeight: '38px',
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: '0.875rem',
                  }),
                }}
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
            {/* Switch */}
            <div className="flex items-center">
              <Switch
                checked={sendMessage}
                onChange={setSendMessage}
                className={classNames(
                  sendMessage ? "bg-indigo-600" : "bg-gray-200",
                  "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                )}
              >
                <span className="sr-only">Use setting</span>
                <span
                  aria-hidden="true"
                  className={classNames(
                    sendMessage ? "translate-x-5" : "translate-x-0",
                    "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                  )}
                />
              </Switch>
              <div className="flex-1 ml-2 sm:ml-3">
                <div>
                  <label
                    htmlFor="toggle"
                    className="text-xs sm:text-[13px] font-medium text-[#111827]"
                  >
                    Message
                  </label>
                </div>
                <div className="-mt-1 sm:-mt-1.5">
                  <button
                    className="text-gray-400 text-[10px] sm:text-xs hover:text-gray-600 transition-colors"
                    onClick={toggleMessageVisibility}
                    type="button"
                  >
                    {isMessageVisible ? (
                      <div className="flex items-center gap-1">
                        <span>Hide Message</span>
                        <IoIosArrowUp className="w-3 h-3" />
                      </div>
                    ) : (
                      <div className="flex items-center gap-1">
                        <span>View Message</span>
                        <IoIosArrowDown className="w-3 h-3" />
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </div>
            {/* Add Guest Button */}
            <button
              onClick={handleAddGuest}
              disabled={guestAddingLoader}
              className="w-full sm:w-auto text-white font-semibold px-4 py-2.5 sm:py-2 rounded-md text-xs sm:text-[13px] focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {guestAddingLoader ? "Sending..." : "Send Link"}
            </button>
          </div>
          <div className="w-full mt-3 sm:mt-4">
            {isMessageVisible && (
              <textarea
                value={`Hello${firstName ? " " + firstName : ""}! \nThis is ${propertyName}. We value your feedback. Please take a moment to leave us a review about your recent experience: [Review Link]. \nThank you.`}
                readOnly
                className="block w-full rounded-md border border-gray-300 px-3 py-2 sm:py-1.5 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 resize-none overflow-y-auto text-xs sm:text-[13px] placeholder:text-gray-900"
                rows="4"
                placeholder="Default status message template text goes here and not editable..."
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddGuestModal;
